"use client";
import React from "react";
import ViewerPdf from "@/components/pdf/Viewer";
import PropTypes from 'prop-types'
const Viewer = ({ isLoading, base64 }) => {
  return <ViewerPdf isLoading={isLoading} base64={base64} />;
};

Viewer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  base64: PropTypes.string.isRequired
} 

export default Viewer;
